import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from '../../../../../app.service';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { FavouriteDialogService } from '../../../favourite-dialog/favourite-dialog.service';
import { DigitalFormService } from '../../digital-form.service';
import { Router } from '@angular/router';
import { CustomerSelectItem, EquipmentSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../../../setup-implement/setup-implement.model';
import { JobsiteSelectionFilter } from '../../../favourite-dialog/favourite-dialog-modal';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { PreferencesService } from '../../../../../modules/preferences/preferences.service';
import { DatePipe } from '@angular/common';
import { MY_FORMATS } from '../../../../../modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-select-equipment',
  templateUrl: './select-equipment.component.html',
  styleUrls: ['./select-equipment.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class SelectEquipmentComponent implements OnInit {
  // Drop-down lists
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  // Search Filters
  selectedCustomer: number;
  selectedJobsite: number; 
  selectedEquipment: number;
  selectedImplement:number;
  selectedCustomerList: number[]=[];
  selectedJobsiteList: number[]=[]; 
  implementList:GenericIdName[]=[];
  formId:number;
  disable:boolean=false;
  inspectionDate:Date;
  isFECR:boolean=false;
  linkedModels:GenericIdName[]=[];
  linkedCustomers:GenericIdName[]=[];
  selectedInspectors: number[]=[];
  uploadId:number;
  inspectors:number[]=[];
  isStartBySupervisor:boolean=false;
  isSupervisour:boolean=false;
  selectedInspectorsCsv: string="";
  constructor( private _appService: AppService,private _equipmentService: GETSetupEquipmentService,
    public _favouriteDialogService:FavouriteDialogService,
    private _implementService: SetupImplementService,
    public _formService:DigitalFormService,private _dialogRef: MatDialogRef<SelectEquipmentComponent>, 
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _router: Router, private _dialog: MatDialog,
    private readonly _pref: PreferencesService,private datepipe:DatePipe) { }
  ngOnInit() {
    let inspectiondate= this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.inspectionDate= new Date(inspectiondate);
    this.formId = this._data.formId;
    this.linkedModels=this._data.linkedModels;
    this.linkedCustomers=this._data.linkedCustomers;
    this.isFECR = this._data.isFECR;
    this.isStartBySupervisor=this._data.isStartBySupervisor;
    this.isSupervisour = this._data.isSupervisour;
    console.log("this.isStartBySupervisor", this.isStartBySupervisor);
    console.log("this.isSupervisour", this.isSupervisour);
    this.loadCustomers();
  }
  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      if(this.linkedCustomers!=null && this.linkedCustomers.length>0 ){
        var val=this.customerList.some(r=> this.linkedCustomers.includes(r))
        console.log("value", val)
        this.customerList= this.linkedCustomers;
      }
    });
  }
  loadJobsitesForCustomer() {
    this.selectedCustomerList=[];
    if (this.selectedCustomer == null)
        return;
    console.log("list",this.selectedCustomer,this.selectedCustomerList)
   // this.selectedCustomerList=null;
    this.selectedJobsite = null;
    this.jobsiteList = null;
    this.selectedEquipment = null;
    this.equipmentList = null;
    this.selectedCustomerList.push(this.selectedCustomer)
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomerList,
      }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
      }
    });
  }
  loadInspectors(customerId: number, jobsiteId: number) {
    this._formService.getInspectorsName(customerId, jobsiteId).subscribe({
      next: (res: any) => {
        console.log("inspectors  res__", res);
        if (res.Status === 1) {
          this.inspectors = res.Data;
          console.log("inspectors", this.inspectors);
        }
      },
      error: (err) => {
        console.error(err.Message);
      }
    });
  }  
  loadImplementsInInventory(){
    if (this.selectedJobsite == null)
      return;
    // this.selectedJobsiteList.push(this.selectedJobsite)
    this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
      this.implementList = r;
    });
  }
  loadEquipmentForJobsite() {
    this.equipmentList=null;
    this.selectedJobsiteList = [];
    if (this.selectedJobsite == null)
      return;
    this.selectedJobsiteList.push(this.selectedJobsite)
    if(this.isFECR==false){  
      var params: number[] = this.selectedJobsiteList;
      this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
        if (r) {
          this.equipmentList = r;
          console.log("r", r);
          this.linkedModels.map(x=>{
            this.equipmentList.map(q=>{
              if(x.Id==q.ModelId){
                q.select=true;
              }
            })
          })
          this.equipmentList= this.equipmentList.filter(x=>x.select==true);
          console.log("this.equipmentList", this.equipmentList);
          this.loadInspectors(this.selectedCustomer, this.selectedJobsite);
        }
      });
    }else { 
      this.loadImplementsInInventory();
    }
  }
  FillForm(){
    this._dialogRef.close(true);
    this.disable=true;
    let inspectiondate = this.datepipe.transform(this.inspectionDate, 'yyyy-MM-dd');
    if(this.isFECR==false) {
      this._favouriteDialogService.CreateUploadForm(this.formId,this.selectedEquipment, inspectiondate, this.selectedInspectorsCsv).subscribe(res=>{
      console.log("res", res)
      this.uploadId=res;
      if(res>0){
        // this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
        //   window.open('/digitalform/fill/' + this.formId + '/' + this.uploadId, '_blank');
        this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
          if(res=="True"){
            this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
          }else{             
            window.open('/digitalform/fill/' + this.formId + '/' + this.uploadId, '_blank'); 
          }
        });
        //Create DFI Inspection Report Records for the form
        this._formService.DFIRportAddRecordsNewInspection(this.uploadId).subscribe(res=>{
        })
      }})
    }else{
      this._favouriteDialogService.CreateUploadFormInFECR(this.formId,this.selectedImplement).subscribe(res=>{
      console.log("res", res)
      this.uploadId=res;
      if(res>0){
        //  this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
        // window.open('/digitalform/fill/' + this.formId + '/' + this.uploadId, '_blank');
        this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
          if(res=="True"){
            this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
          }else{             
            window.open('/digitalform/fill/' + this.formId + '/' + this.uploadId, '_blank');
          }
        });
      }})
    }
  }
  onNoClick(){
    this._dialogRef.close(false);
  }
  onInspectorsChange(event: any) {
    this.selectedInspectors = event.value; // always an array
    console.log('Selected Inspectors:', this.selectedInspectors);
    this.selectedInspectorsCsv = this.selectedInspectors.join(',');
  }
}
